import store from "../store/store";
import {
  addAlert,
  removeAlert,
  setShowPrinterAlert,
} from "../store/actions/alertsSlice";
import { addActionToRegistry } from "../store/actions/alertActionsRegistry";

export const dispatchAddAlert = ({
  label = "ATENÇÃO",
  message,
  btnLabel = "Ok",
  type = "normal",
  order_index = null,
  order_id = null,
  customer_id = null,
  action,
}) => {
  const alertId = Date.now();
  const actionId = `action_${alertId}`;

  if (action) {
    addActionToRegistry(actionId, action);
  } else {
    addActionToRegistry(actionId, () => dispatchRemoveAlert(alertId));
  }

  store.dispatch(
    addAlert({
      id: alertId,
      label: label,
      message: message,
      type: type,
      order_index: order_index,
      order_id: order_id,
      customer_id: order_id,
      btnLabel: btnLabel,
      actionId: actionId,
    })
  );
};

export const dispatchRemoveAlert = (alertId) => {
  store.dispatch(removeAlert(alertId));
};

export const dispatchSetShowPrinterAlert = (value) => {
  store.dispatch(setShowPrinterAlert(value));
};
